type Translate = (key: string, fallback: string) => string;

/** Presentation only: never use location wording to decide booking rules. */
export function bookingLocationCopy(rentalType: string, t: Translate) {
  if (rentalType === "event") {
    return {
      title: t("booking.event_delivery_location", "Delivery location"),
      help: t("booking.event_delivery_location_help", "Where would you like the car delivered? Search by city, postcode, hotel or business name."),
      prompt: t("booking.event_delivery_location_prompt", "Where should the car be delivered?"),
    };
  }
  if (rentalType === "chauffeured") {
    return {
      title: t("booking.pickup_location", "Pick-up location"),
      help: t("booking.chauffeur_pickup_location_help", "Where would you like to be picked up? Search by city, postcode, hotel or business name."),
      prompt: t("booking.chauffeur_pickup_location_prompt", "Where should we pick you up?"),
    };
  }
  return {
    title: t("booking.pickup_return_location", "Pick-up / Return location"),
    help: t("booking.pickup_location_help", "Where would you like to pick up the car? Search by city, postcode, hotel or business name."),
    prompt: t("booking.location_required_label", "Where should we meet you?"),
  };
}
